import { useState } from 'react';

type Props = {
  initialName: string;
  initialSpectator: boolean;
  onJoin: (name: string, spectator: boolean) => void;
};

export const JoinDialog = ({ initialName, initialSpectator, onJoin }: Props) => {
  const [name, setName] = useState(initialName);
  const [spectator, setSpectator] = useState(initialSpectator);

  const trimmed = name.trim();

  return (
    <div className="overlay">
      <form
        className="dialog"
        onSubmit={(event) => {
          event.preventDefault();
          if (trimmed) onJoin(trimmed, spectator);
        }}
      >
        <h1>Join the session</h1>
        <p className="dialog-sub">Pick the name your team will recognise.</p>

        <label className="field">
          <span>Your name</span>
          {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
          <input
            autoFocus
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="e.g. Max"
            maxLength={32}
            autoComplete="nickname"
          />
        </label>

        <label className="checkbox">
          <input
            type="checkbox"
            checked={spectator}
            onChange={(event) => setSpectator(event.target.checked)}
          />
          <span>
            Join as spectator
            <small>Watch and run the session without casting a card.</small>
          </span>
        </label>

        <button type="submit" className="btn btn-primary btn-lg" disabled={!trimmed}>
          Join
        </button>
      </form>
    </div>
  );
};
